














import { HomeBanner } from '@/types/home';
import { defineComponent, ref, PropType } from '@vue/composition-api';
import Banner from '@tencent/wphk-components-banner';
import { useBannerList } from '../../hooks/use-banner-list';

export default defineComponent({
  name: 'LeftBanner',
  components: {
    Banner,
  },
  props: {
    leftBannerList: {
      type: Array as PropType<HomeBanner[]>,
      required: true,
    },
  },
  setup(props) {
    const { bannerList } = useBannerList(ref(props.leftBannerList), 'leftBanner');
    return {
      bannerList,
    };
  },
});
